/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from 'react';
import { Button, Form, Input, Tabs, Tag, Tooltip } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate, useParams } from 'react-router-dom';
import IconBack from '../../../assets/Images/icons/icon-back';
import { ROUTER } from '../../../constants/router';
import useNotify from '../../../context/Notification/useNotify';
import GlobalService from '../../../services/Global.service';
import WorkflowService from '../../../services/Workflow.service';
import useQuery from '../../../util/useQuery';
import ModalApply from './ModalApply';
import TaskCanceled from './TaskCanceled';
import WorkflowStep from './WorkflowStep';
import ModalCheck from './ModalCheck';
import usePermission from '../../../hooks/usePermission';

const WorkflowDetail = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { workflowId } = useParams();

    const notify = useNotify();
    const params = useQuery();

    const [open, setOpen] = useState(false);
    const [workflow, setWorkflow] = useState();
    const [state, setState] = useState([]);
    const [department, setDepartment] = useState([]);
    const [form] = Form.useForm();

    const [isEdited, setIsEdited] = useState(false);

    // Modal Comfirm
    const [openConfirm, setOpenConfirm] = useState(false);
    const [loading] = useState(false);

    const ref = useRef();

    const { isAuditor, isUser } = usePermission();

    const statusSwitch = (record) => {
        if (record?.workflowStatus) {
            if (record.workflowStatus.toLowerCase() === 'active') {
                return record.isCanInactive === false ? (
                    <div className="text-center">
                        <Tag className="rounded-xl -my-1 text-center bg-[#4ACE8F] border-[#4ACE8F] text-white w-auto">
                            {t('Active')}
                        </Tag>
                    </div>
                ) : (
                    <div className="text-center">
                        <Button
                            disabled={isAuditor || isUser}
                            className="text-[15px]"
                            block
                            size="large"
                            danger
                            onClick={() => {
                                console.log('click');
                                setOpenConfirm(true);
                            }}
                        >
                            <div className="flex gap-2">
                                <div className="place-self-center my-1">
                                    {IconInactive}
                                </div>
                                <div>{t('InActive')}</div>
                            </div>
                        </Button>
                    </div>
                );
            } else {
                return (
                    <div className="text-center">
                        <Tag className="flex justify-center space-x-1 rounded-xl -my-1 text-center bg-[#F0536F] border-[#F0536F] text-white w-auto">
                            <div>{t('InActive')}</div>
                            <Tooltip
                                className="cursor-pointer"
                                placement="bottom"
                                overlayClassName="min-w-[20%]"
                                title={
                                    <div className="whitespace-pre-line">
                                        {t('workFlow.InActiveTootip', {
                                            dsTypeName: record?.dsTypeName,
                                            domainName: record?.domainName,
                                        })}
                                    </div>
                                }
                            >
                                <div className="text-xs">
                                    <InfoCircleOutlined />
                                </div>
                            </Tooltip>
                        </Tag>
                    </div>
                );
            }
        }
    };

    const onFinish = async (values) => {
        let payload = { workflowId, ...values };
        payload.workflowStep = values?.workflowStep.map((value, index) => {
            return {
                ...value,
                stepId: value.isNewStep ? '' : value.stepId,
                sequence: index + 1,
            };
        });
        try {
            const { data } = await WorkflowService.updateWorkflow(
                payload,
                workflowId
            );
            if (data?.resultCode === 1) {
                setOpen(false);
                notify({
                    title: t('common.Success'),
                    description: t('Successfully to save data'),
                });
                navigate(`${ROUTER.DS_360.WORKFLOW}`);
            } else {
                setOpen(false);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('Failed to save data'),
                });
            }
        } catch (error) {
            setOpen(false);
            notify({
                type: 'error',
                title: t('common.Fail'),
                description: t('Failed to save data'),
            });
        }
    };

    const getWorkflow = async () => {
        const { data } = await WorkflowService.getWorkflow(workflowId);
        if (data?.resultData) {
            const resultData = data?.resultData;
            setWorkflow(data?.resultData);
            const workflowStep = data?.resultData?.workflowStep?.sort(
                (a, b) => a.sequence - b.sequence
            );
            form.resetFields();
            form.setFieldsValue({
                taskCanceled: resultData?.taskCanceled,
                workflowName: resultData?.workflowName,
                workflowDescription: resultData?.workflowDescription,
                workflowStep,
            });
        }
    };

    useEffect(() => {
        const getStateDropdown = async () => {
            try {
                const { data } = await GlobalService.getStateDropdown();
                if (data?.resultData) {
                    setState(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        const getDepartmentAll = async () => {
            try {
                const { data } = await WorkflowService.getDepartmentAll();
                if (data?.resultData) {
                    setDepartment(data?.resultData);
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStateDropdown();
        getDepartmentAll();
        getWorkflow(workflowId);
    }, [workflowId]);

    const [errorStep, setErrorStep] = useState();

    const validator = async () => {
        await navigate(`${ROUTER.DS_360.WORKFLOW}/${workflowId}?tab=2`);
        await form
            .validateFields()
            .then(async () => {
                await setOpen(true);
            })
            .catch(({ errorFields }) => {
                // console.log(errorFields);
                if (errorFields.length > 0) {
                    const workflowStep = errorFields.map((errorField) =>
                        errorField.name.includes('workflowStep')
                            ? 'workflowStep'
                            : ''
                    );
                    const taskCanceled = errorFields.map((errorField) =>
                        errorField.name.includes('taskCanceled')
                            ? 'taskCanceled'
                            : ''
                    );
                    if (workflowStep.includes('workflowStep')) {
                        navigate(`${ROUTER.DS_360.WORKFLOW}/${workflowId}`);
                        setErrorStep(`${errorFields[0].name[1]}`);
                    } else if (taskCanceled.includes('taskCanceled')) {
                        navigate(
                            `${ROUTER.DS_360.WORKFLOW}/${workflowId}?tab=2`
                        );
                    }
                }
            });
    };

    return (
        <div>
            <div className="title flex space-x-2">
                <div>
                    <Link to={`${ROUTER.DS_360.WORKFLOW}`}>
                        <IconBack />
                    </Link>
                </div>
                <div>{t('Edit Workflow')}</div>
            </div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('Data Subject 360')} /{' '}
                </span>
                <span className="text-sm text-gray-400">
                    {t('Workflow List')} /{' '}
                </span>
                {t('Edit Workflow')}
            </div>
            <Form
                scrollToFirstError={{
                    behavior: 'smooth',
                    block: 'center',
                }}
                form={form}
                onFinish={onFinish}
                layout="vertical"
                initialValues={{
                    applyWorkflowUnderDomain: false,
                    workflowUnderDomain: [workflowId],
                }}
            >
                <div className="mt-6 bg-white p-4 px-6 rounded-lg flex justify-between items-center mb-4">
                    <div className="text-xl font-medium">
                        {t('Workflow Detail')}
                    </div>
                    <div className="text-right space-y-2">
                        {!isEdited ? (
                            <Button
                                onClick={() => {
                                    setIsEdited(true);
                                    navigate(
                                        `${ROUTER.DS_360.WORKFLOW}/${workflowId}`
                                    );
                                }}
                                type="primary"
                                size="large"
                                className="px-10"
                                hidden={
                                    workflow?.workflowStatus.toLowerCase() ===
                                    'inactive'
                                }
                                disabled={
                                    isAuditor || isUser || !workflow?.isEdit
                                }
                            >
                                {t('Edit')}
                            </Button>
                        ) : (
                            <div className="space-x-2">
                                <Button
                                    onClick={() => {
                                        setIsEdited(false);
                                        getWorkflow();
                                    }}
                                    ghost
                                    type="primary"
                                    size="large"
                                    className="px-10"
                                >
                                    {t('Cancel')}
                                </Button>
                                <Button
                                    // htmlType="submit"
                                    type="primary"
                                    size="large"
                                    className="px-10"
                                    onClick={validator}
                                >
                                    {t('Apply')}
                                </Button>
                                <Button htmlType="submit" ref={ref} hidden />
                            </div>
                        )}
                        <div
                            className="text-[#F0536F] text-sm"
                            hidden={
                                workflow?.workflowStatus.toLowerCase() ===
                                    'inactive' ||
                                (workflow?.workflowStatus.toLowerCase() !==
                                    'inactive' &&
                                    workflow?.isEdit === true)
                            }
                        >
                            {t(
                                'There is a pending authorization request so the workflow cannot be edited'
                            )}
                        </div>
                        <div>
                            {t('Last Update')}: {workflow?.lastUpdate},{' '}
                            {t('Update by')}: {workflow?.updateBy}
                        </div>
                    </div>
                </div>

                <div className="grid grid-cols-3 gap-4">
                    <div className="col-span-1 bg-white rounded-lg p-4 px-6 h-max">
                        <div
                            className="flex justify-between items-center pb-2 mb-4"
                            style={{ borderBottom: '1px solid #F2F2F2' }}
                        >
                            <div className="text-sm font-semibold">
                                ID : {workflow?.workflowCode}
                            </div>
                            <div>{statusSwitch(workflow)}</div>
                        </div>
                        <div>
                            <Form.Item
                                name="workflowName"
                                label={t('Workflow Name')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorText.requiredField'),
                                    },
                                ]}
                            >
                                <Input
                                    disabled={!isEdited}
                                    size="large"
                                    placeholder={t('Workflow Name')}
                                    maxLength={30}
                                    showCount
                                />
                            </Form.Item>
                            <Form.Item
                                name="workflowDescription"
                                label={t('Workflow Description')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('errorText.requiredField'),
                                    },
                                ]}
                            >
                                <Input.TextArea
                                    disabled={!isEdited}
                                    rows={3}
                                    placeholder={t('Workflow Description')}
                                />
                            </Form.Item>
                        </div>
                        <div className="space-y-2">
                            <div>
                                <div className="text-purple text-sm font-semibold">
                                    {t('Domain')}
                                </div>
                                <div className="text-sm">
                                    {workflow?.domainName}
                                </div>
                            </div>
                            <div>
                                <div className="text-purple text-sm font-semibold">
                                    {t('Ds Type')}
                                </div>
                                <div className="text-sm">
                                    {workflow?.dsTypeName ?? '-'}
                                </div>
                            </div>
                            <div>
                                <div className="text-purple text-sm font-semibold">
                                    {t('Data Subject Rights')}
                                </div>
                                <div className="text-sm">
                                    {t(
                                        'This workflow applies to rights requests as follows'
                                    )}
                                    <ul className="pt-2">
                                        {workflow?.dsRights?.map((ds) => (
                                            <li key={ds?.dsRightsId}>
                                                {ds?.dsRightsName}
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-span-2 bg-white rounded-lg p-4 px-6">
                        <Tabs
                            onChange={(key) => {
                                // setKeyTab(key);
                                navigate(
                                    `${ROUTER.DS_360.WORKFLOW}/${workflowId}?tab=${key}`
                                );
                            }}
                            activeKey={params.get('tab') || '1'}
                        >
                            <Tabs.TabPane tab={t('Workflow Step')} key="1">
                                <WorkflowStep
                                    setErrorStep={setErrorStep}
                                    errorStep={errorStep}
                                    disabled={!isEdited}
                                    workflow={workflow}
                                    state={state}
                                    department={department}
                                    form={form}
                                />
                            </Tabs.TabPane>
                            <Tabs.TabPane tab={t('Task Canceled')} key="2">
                                <TaskCanceled
                                    disabled={!isEdited}
                                    state={state}
                                    department={department}
                                />
                            </Tabs.TabPane>
                        </Tabs>
                    </div>
                </div>
                {workflow?.workflowCode && (
                    <ModalApply
                        domainId={workflow?.domainId}
                        workflowCode={workflow?.workflowCode}
                        btnRef={ref}
                        form={form}
                        open={open}
                        handelClose={() => setOpen(false)}
                    />
                )}
            </Form>
            <ModalCheck
                title={''}
                text={t(
                    `${t('Please check My Task')} \n${t(
                        'and complete the request before it becomes inactive'
                    )}`
                )}
                loading={loading}
                open={openConfirm}
                confirmText={t('Checked')}
                cancelText={t('Cancel')}
                handelClose={() => {
                    setOpenConfirm(false);
                }}
                workflow={workflow}
            />
        </div>
    );
};

export default WorkflowDetail;

const IconInactive = (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.5282 13.4715L6.72423 7.66681H3.6669V6.33348H5.3909L4.05757 5.00014H3.6669C3.13647 5.00014 2.62776 5.21086 2.25268 5.58593C1.87761 5.961 1.6669 6.46971 1.6669 7.00014C1.6669 7.53057 1.87761 8.03928 2.25268 8.41436C2.62776 8.78943 3.13647 9.00014 3.6669 9.00014H5.6669V10.3335H3.6669C2.8554 10.3341 2.07153 10.0388 1.46228 9.50272C0.853036 8.96668 0.460255 8.2268 0.357598 7.42182C0.254941 6.61684 0.44946 5.80207 0.904677 5.13027C1.35989 4.45848 2.04454 3.97583 2.83023 3.77281L0.528232 1.47148L1.47156 0.528809L13.4716 12.5288L12.5289 13.4708V13.4715H12.5282ZM12.4242 9.59548L11.4722 8.64414C11.8225 8.40145 12.0862 8.0532 12.2247 7.65017C12.3632 7.24714 12.3693 6.8104 12.2422 6.40363C12.1151 5.99686 11.8614 5.64133 11.5181 5.38886C11.1747 5.1364 10.7597 5.00021 10.3336 5.00014H8.33356V3.66681H10.3336C11.0232 3.66689 11.6959 3.88088 12.2588 4.27929C12.8217 4.6777 13.2472 5.2409 13.4767 5.89128C13.7061 6.54165 13.7281 7.24718 13.5397 7.91061C13.3514 8.57403 12.9619 9.1627 12.4249 9.59548H12.4242Z"
            fill="#F0536F"
        />
    </svg>
);
